import { render } from "./AGBGenerator.vue?vue&type=template&id=ea5bd968&scoped=true"
import script from "./AGBGenerator.vue?vue&type=script&lang=js"
export * from "./AGBGenerator.vue?vue&type=script&lang=js"

import "./AGBGenerator.vue?vue&type=style&index=0&id=ea5bd968&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea5bd968"]])

export default __exports__